import React from 'react';

function Pagination({ currentPage, totalPages, onPageChange }) {
    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;

        if (totalPages <= maxVisiblePages) {
            // Show all pages if total pages are less than or equal to maxVisiblePages
            for (let i = 1; i <= totalPages; i++) {
                pages.push(
                    <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(i)}
                            aria-current={currentPage === i ? 'page' : undefined}

                        >
                            {i}
                        </a>
                    </li>
                );
            }
        } else {
            // Handle large numbers of pages
            if (currentPage <= 3) {
                // Show first three pages and then "..." and last two pages
                for (let i = 1; i <= 3; i++) {
                    pages.push(
                        <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                            <a
                                href="#"
                                className="page-link"
                                role="button"
                                tabIndex={0}
                                onClick={() => onPageChange(i)}
                                aria-current={currentPage === i ? 'page' : undefined}
                            >
                                {i}
                            </a>
                        </li>
                    );
                }
                pages.push(<li key="dots1" className="page-item disabled"><span className="page-link">...</span></li>);
                pages.push(
                    <li key={totalPages - 1} className={`page-item ${currentPage === totalPages - 1 ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(totalPages - 1)}
                            aria-current={currentPage === totalPages - 1 ? 'page' : undefined}
                        >
                            {totalPages - 1}
                        </a>
                    </li>
                );
                pages.push(
                    <li key={totalPages} className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(totalPages)}
                            aria-current={currentPage === totalPages ? 'page' : undefined}
                        >
                            {totalPages}
                        </a>
                    </li>
                );
            } else if (currentPage >= totalPages - 2) {
                // Show first two pages and then "..." and the last three pages
                pages.push(
                    <li key={1} className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(1)}
                            aria-current={currentPage === 1 ? 'page' : undefined}
                        >
                            1
                        </a>
                    </li>
                );
                pages.push(
                    <li key={2} className={`page-item ${currentPage === 2 ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(2)}
                            aria-current={currentPage === 2 ? 'page' : undefined}
                        >
                            2
                        </a>
                    </li>
                );
                pages.push(<li key="dots2" className="page-item disabled"><span className="page-link">...</span></li>);
                for (let i = totalPages - 2; i <= totalPages; i++) {
                    pages.push(
                        <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                            <a
                                href="#"
                                className="page-link"
                                role="button"
                                tabIndex={0}
                                onClick={() => onPageChange(i)}
                                aria-current={currentPage === i ? 'page' : undefined}
                            >
                                {i}
                            </a>
                        </li>
                    );
                }
            } else {
                // Show first two pages, "..." in the middle, currentPage in the middle, and last two pages
                pages.push(
                    <li key={1} className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(1)}
                            aria-current={currentPage === 1 ? 'page' : undefined}
                        >
                            1
                        </a>
                    </li>
                );
                pages.push(
                    <li key={2} className={`page-item ${currentPage === 2 ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(2)}
                            aria-current={currentPage === 2 ? 'page' : undefined}
                        >
                            2
                        </a>
                    </li>
                );
                pages.push(<li key="dots3" className="page-item disabled"><span className="page-link">...</span></li>);

                // Update this block to include the next page when on the 3rd page
                for (let i = currentPage - 1; i <= currentPage + 2 && i <= totalPages; i++) {
                    pages.push(
                        <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                            <a
                                href="#"
                                className="page-link"
                                role="button"
                                tabIndex={0}
                                onClick={() => onPageChange(i)}
                                aria-current={currentPage === i ? 'page' : undefined}
                            >
                                {i}
                            </a>
                        </li>
                    );
                }

                pages.push(<li key="dots4" className="page-item disabled"><span className="page-link">...</span></li>);
                pages.push(
                    <li key={totalPages - 1} className={`page-item ${currentPage === totalPages - 1 ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(totalPages - 1)}
                            aria-current={currentPage === totalPages - 1 ? 'page' : undefined}
                        >
                            {totalPages - 1}
                        </a>
                    </li>
                );
                pages.push(
                    <li key={totalPages} className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
                        <a
                            href="#"
                            className="page-link"
                            role="button"
                            tabIndex={0}
                            onClick={() => onPageChange(totalPages)}
                            aria-current={currentPage === totalPages ? 'page' : undefined}
                        >
                            {totalPages}
                        </a>
                    </li>
                );
            }
        }

        return pages;
    };


    return (
        <div className="d-flex justify-content-end align-items-center">
            <ul className="pagination">
                <li className={`page-item arrow-pagination ${currentPage === 1 ? 'disabled' : ''}`}>
                    <span
                        className="page-link"
                        onClick={handlePrevious}
                        aria-label="Previous"
                    >
                        <span aria-hidden="true">
                            <svg
                                width={9}
                                height={15}
                                viewBox="0 0 9 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.11735 1.59326L2 7.71061L8.11735 13.828"
                                    stroke="#28495B"
                                    strokeWidth="1.52934"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>
                    </span>
                </li>
                {renderPageNumbers()}
                <li className={`page-item arrow-pagination ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <span
                        className="page-link"
                        onClick={handleNext}
                        aria-label="Next"
                    >
                        <span aria-hidden="true">
                            <svg
                                width={9}
                                height={15}
                                viewBox="0 0 9 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M0.88265 1.59326L7 7.71061L0.88265 13.828"
                                    stroke="#9E4A9A"
                                    strokeWidth="1.52934"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>
                    </span>
                </li>
            </ul>
        </div>
    );
}

export default Pagination;
